import * as ssr from '../../ssr';
export default function getSSRSuccess(type) {
  if (type !== 'page_load') {
    return undefined;
  }
  return ssr.getSSRSuccess();
}